export function popupGallery() {
  const modal = document.querySelector('.js-popup-gallery');
  if(modal) {
    const modalContainer = modal.querySelector('.js-popup-gallery-container');
    const modalElement = modal.querySelector('.js-popup-gallery-element');
    const closeButtons = modal.querySelectorAll('.js-popup-gallery-close');

    function openModal(content, type) {
      if(modalElement) modalElement.innerHTML = '';
      if (type == 'video') {
        const video = document.createElement('video');
        video.src = content;
        video.autoplay = true;
        video.loop = true;
        video.muted = true;
        video.playsInline = true;
        video.style.width = '100%';
        video.style.height = '100%';
        video.style.objectFit = 'contain';
        if(modalElement) modalElement.appendChild(video);
        video.play()
      } else if (type == 'image') {
        const img = document.createElement('img');
        img.src = content;
        img.style.width = '100%';
        img.style.height = '100%';
        img.style.objectFit = 'contain';
        if(modalElement) modalElement.appendChild(img);
      }
      modal.classList.add('is-active');
      if(modalContainer) modalContainer.classList.add('is-active');
    }

    function closeModal(e) {
      if (e) e.preventDefault();
      modal.classList.remove('is-active');
      if(modalContainer) modalContainer.classList.remove('is-active');
      
      // Stop video if playing
      if(modalElement) {
        const video = modalElement.querySelector('video');
        if (video) {
          video.pause();
          video.currentTime = 0;
        }
      }
    }

    // Close modal event listeners
    if(closeButtons) {
      closeButtons.forEach(button => {
        button.addEventListener('click', closeModal);
      });
    }

    // Close on ESC key
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && modal.classList.contains('is-active')) {
        closeModal();
      }
    });

    // Return the functions for external use
    return {
      openModal,
      closeModal
    };
  }
}